// Driving-time lookups via the free public OSRM demo server (no API key, CORS
// open). Keep volume low — it's a courtesy service. Returns null on any error so
// callers can fall back gracefully.
export const driveMinutes = async (
  fromLat: number,
  fromLng: number,
  toLat: number,
  toLng: number,
  signal?: AbortSignal
): Promise<number | null> => {
  const url =
    `https://router.project-osrm.org/route/v1/driving/` +
    `${fromLng},${fromLat};${toLng},${toLat}?overview=false`;
  try {
    const res = await fetch(url, { signal });
    if (!res.ok) return null;
    const data = await res.json();
    const sec = data?.routes?.[0]?.duration;
    return typeof sec === "number" ? sec / 60 : null;
  } catch {
    return null;
  }
};

// Human label for a driving time, e.g. "~8 min", "~1 h 45 min".
export const formatDriveTime = (minutes: number): string => {
  const m = Math.max(1, Math.round(minutes));
  if (m < 60) return `~${m} min`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  return rem === 0 ? `~${h} h` : `~${h} h ${rem} min`;
};
